import { FileTextOutlined, SearchOutlined } from '@ant-design/icons';
import {
  Breadcrumb,
  Button,
  Col,
  Input,
  Pagination,
  Popconfirm,
  Row,
  Space,
  Table,
  Tooltip,
  message
} from 'antd';
import dayjs from 'dayjs';
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Link, useNavigate } from 'react-router-dom';
import { ReactComponent as ArchiveRestore } from "../../Images/ArchiveRestore.svg";
import { ReactComponent as Back } from '../../Images/Back.svg';
import { ReactComponent as FilterIcon } from '../../Images/FilterIcon.svg';
import { fetchArchivedDieToolist, resetDieToolList, unArchiveDieTool } from '../../slices/die-tool';

export default function ArchiveDieGroup() {
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [orderBy, setOrderBy] = useState('')
  const [page, setPage] = useState(1);
  const { user: currentUser } = useSelector((state) => state?.auth);
  const [pagesize, setPageSize] = useState(10);
  const navigate = useNavigate();
  const [inputValue, setInputValue] = useState(localStorage.getItem('ArchiveDieTool') || '');
  const [search, setSearch] = useState(localStorage.getItem('ArchiveDieTool') || '');

  const rowSelection = {
    selectedRowKeys,
    onChange: (selectedKeys) => {
      setSelectedRowKeys(selectedKeys);
    },
  };

  const dispatch = useDispatch();

  const { data = [], totalRecord = 0, status } = useSelector(state => state.dieTool || {});
  useEffect(() => {
    dispatch(resetDieToolList());
    dispatch(fetchArchivedDieToolist({ page, pagesize, ...(search && { search: search }), ...(orderBy && { ordering: orderBy }) }));
  }, [page, pagesize, search, orderBy]);

  const handleSearch = (e) => {
    const value = e.target.value;
    setInputValue(value);
    setSearch(value);
    localStorage.setItem('ArchiveDieTool', value);
  };

  const resetFilter = () => {
    setSearch('');
    setInputValue('');
    setOrderBy(null); // if applicable
    localStorage.removeItem('ArchiveDieTool');
    dispatch(fetchArchivedDieToolist({ page: 1, pagesize }));
  };

  const handlePageChange = (newPage) => {
    setPage(newPage);
  };

  const handleRestore = (id) => {
    if (!id) {
      message.error('Missing ID for deletion!');
      return;
    }

    dispatch(unArchiveDieTool(id))
      .unwrap()
      .then(() => {
        message.success('Die Tool Unarchived successfully!');
      })
      .catch((err) => {
        console.error('Delete Error:', err); // Debugging the error
        message.error(`Error: ${err || 'Failed to unarchive the profile.'}`);
      });
  };

  const GetSortingEnumValue = (sortField, sortOrder) => {
    let sortingEnumKey = "id";

    if (sortField === "tool_number" && sortOrder === "ascend") {
      sortingEnumKey = "tool_number";
    }
    if (sortField === "tool_number" && sortOrder === "descend") {
      sortingEnumKey = "-tool_number";
    }
    if (sortField === "die_size__die_height" && sortOrder === "ascend") {
      sortingEnumKey = "die_size__die_height";
    }
    if (sortField === "die_size__die_height" && sortOrder === "descend") {
      sortingEnumKey = "-die_size__die_height";
    }
    if (sortField === "die_cavity" && sortOrder === "ascend") {
      sortingEnumKey = "die_cavity";
    }
    if (sortField === "die_cavity" && sortOrder === "descend") {
      sortingEnumKey = "-die_cavity";
    }
    if (sortField === "is_active" && sortOrder === "ascend") {
      sortingEnumKey = "is_active";
    }
    if (sortField === "is_active" && sortOrder === "descend") {
      sortingEnumKey = "-is_active";
    }
    if (sortField === "total_running_qty" && sortOrder === "ascend") {
      sortingEnumKey = "total_running_qty";
    }
    if (sortField === "total_running_qty" && sortOrder === "descend") {
      sortingEnumKey = "-total_running_qty";
    }
    if (sortField === "die_sub_category" && sortOrder === "ascend") {
      sortingEnumKey = "die_sub_category";
    }
    if (sortField === "die_sub_category" && sortOrder === "descend") {
      sortingEnumKey = "-die_sub_category";
    }
    if (sortField === "ownership" && sortOrder === "ascend") {
      sortingEnumKey = "ownership";
    }
    if (sortField === "ownership" && sortOrder === "descend") {
      sortingEnumKey = "-ownership";
    }
    if (sortField === "run_under_deviation" && sortOrder === "ascend") {
      sortingEnumKey = "run_under_deviation";
    }
    if (sortField === "run_under_deviation" && sortOrder === "descend") {
      sortingEnumKey = "-run_under_deviation";
    }
    if (sortField === "purchase_price" && sortOrder === "ascend") {
      sortingEnumKey = "purchase_price";
    }
    if (sortField === "purchase_price" && sortOrder === "descend") {
      sortingEnumKey = "-purchase_price";
    }

    return sortingEnumKey;
  };


  const handleTableChange = async (pagination, filters, sorter, ordering) => {
    if (sorter?.columnKey && sorter.order) {
      const orderBy = GetSortingEnumValue(sorter.columnKey, sorter.order);
      setOrderBy(orderBy);
    }
    setPageSize(pagination.pageSize);
  };

  const columns = [
    {
      title: 'Sr. No.',
      dataIndex: 'id',
      key: 'id',
      width: '80px',
      render: (text, record, index) => (page - 1) * pagesize + index + 1,
      sorter: false,
    },
    {
      title: 'Tool No.',
      dataIndex: 'tool_number',
      key: 'tool_number',
      width: '100px',
      sorter: true,
      render: (text, record) => {
        return (
          <span>{record?.die?.die_number ? record?.die?.die_number + '-' + record?.tool_number : 'N/A'} </span>
        )
      }
    },
    {
      title: 'Tool Size',
      dataIndex: 'die_size',
      key: 'die_size',
      width: '100px',
      sorter: true,
      render: (record) => {
        return (
          <span>{record?.die_width ? record?.die_width + ' X ' + record?.die_height : 'N/A'} </span>
        )
      }
    },
    {
      title: 'Current KG/MTR',
      dataIndex: 'wt_kg_p_mt',
      key: 'wt_kg_p_mt',
      width: '100px',
      sorter: true,
      render: (text, record) => {
        return (
          <span>{record?.die && record?.die?.wt_kg_p_mt ? record?.die?.wt_kg_p_mt : 'N/A'}</span>
        );
      },
    },

    {
      title: 'Recived Date',
      dataIndex: 'received_date',
      key: 'received_date',
      width: '100px',
      sorter: true,
      render: (record) => {
        return (
          <span>{record !== null ? dayjs(record).format('DD-MM-YYYY') : 'N/A'} </span>
        )
      }
    },
    {
      title: 'Order Date',
      dataIndex: 'order_date',
      key: 'order_date',
      width: '100px',
      sorter: true,
      render: (record) => {
        return (
          <span>{record !== null ? dayjs(record).format('DD-MM-YYYY') : 'N/A'} </span>
        )
      }
    },
    {
      title: 'Die Cavity',
      dataIndex: 'die_cavity',
      key: 'die_cavity',
      width: '100px',
      sorter: true,
    },
    {
      title: 'Die Received Status',
      dataIndex: 'is_active',
      key: 'is_active',
      width: '100px',
      render: status => (status === true ? 'Received' : 'Not Received'),
      sorter: true,
    },
    {
      title: 'Total Running QTY (kg)',
      dataIndex: 'total_running_qty',
      key: 'total_running_qty',
      width: '100px',
      sorter: true,
    },
    {
      title: 'Rack No.',
      dataIndex: 'rac_no',
      key: 'rac_no',
      width: '100px',
      sorter: true,
      render: (text, record) => {
        return (
          <span>{record.rac_no !== null ? record.rac_no : 'N/A'} </span>
        )
      }
    },
    {
      title: 'Row No.',
      dataIndex: 'row_no',
      width: '100px',
      key: 'row_no',
      sorter: true,
      render: (text, record) => {
        return (
          <span>{record.row_no !== null ? record.row_no : 'N/A'} </span>
        )
      }
    },
    {
      title: 'Column No.',
      dataIndex: 'column_no',
      width: '100px',
      key: 'column_no',
      sorter: true,
      render: (text, record) => {
        return (
          <span>{record.column_no !== null ? record.column_no : 'N/A'} </span>
        )
      }
    },
    {
      title: 'Vendor',
      dataIndex: 'developer',
      key: 'developer',
      width: '100px',
      sorter: true,
      render: (text, record) => {
        return (
          <span>{record?.developer !== null ? record?.developer?.vendor_registered_name : 'N/A'} </span>
        )
      }
    },
    {
      title: 'Ownership',
      dataIndex: 'ownership',
      key: 'ownership',
      width: '100px',
      sorter: true,
    },
    {
      title: 'Drawing No.',
      dataIndex: 'drawing_no',
      key: 'drawing_no',
      width: '100px',
      sorter: true,
    },
    {
      title: 'Total Running Metric Ton',
      dataIndex: 'total_running_ton',
      key: 'total_running_ton',
      width: '100px',
      sorter: true,
    },
    {
      title: 'Developer Ref. No',
      dataIndex: 'developer_ref_no',
      key: 'developer_ref_no',
      width: '100px',
      sorter: true,
    },
    {
      title: 'Run Under Deviation',
      dataIndex: 'run_under_deviation',
      key: 'run_under_deviation',
      width: '100px',
      sorter: true,
      render: (run_under_deviation) => {
        return (

          <span> {run_under_deviation ? run_under_deviation : 'N/A'}</span>

        )
      }
    },
    {
      title: 'Price',
      dataIndex: 'purchase_price',
      key: 'purchase_price',
      width: '100px',
      sorter: true,
      render: (text, record) => {
        return (
          <p style={{ textAlign: 'end' }}>
            {`\u20B9 ${record?.purchase_price?.toLocaleString('en-IN', { maximumFractionDigits: 0 }) || 0}`}
          </p>
        )
      }
    },
    {
      title: 'Archive At',
      dataIndex: 'archive_at',
      key: 'archive_at',
      width: '100px',
      sorter: true,
      render: (record) => {
        return (
          <span>{record ? dayjs(record).format('DD-MM-YYYY HH:mm') : 'N/A'} </span>
        )
      }
    },
    {
      title: 'Archive By',
      dataIndex: 'updated_by',
      key: 'updated_by',
      width: '100px',
      sorter: true,
      render: ((record) => {
        return (
          <span>{record ? `${record?.first_name} ${record?.last_name}` : 'N/A'} </span>
        )
      })
    },
    {
      title: 'Remarks',
      dataIndex: 'remarks',
      width: '100px',
      key: 'remarks',
      sorter: true,
      render: (remarks) => {
        return (
          <span>{remarks ? remarks : 'N/A'} </span>
        )
      }
    },
    {
      title: 'Die Life Card',
      width: '100px',
      dataIndex: 'id', // Use `id` here for proper alignment and access
      key: 'action',
      render: (record) => (
        <Space>
          {currentUser.permissions.permissions.die.includes("die|view_dietool") && (
            <Tooltip placement="top" title={'View Die Life Card'}>
              <Link to={`/die-life-card/${record?.id}`} target="_blank">
                <FileTextOutlined />
              </Link>
            </Tooltip>
          )}
        </Space>
      ),
    },
    {
      title: 'Action',
      width: '100px',
      dataIndex: 'id', // Use `id` here for proper alignment and access
      key: 'action',
      render: (text, record) => (
        <Space>
          <Tooltip placement="top" title={"Unarchive"}>
            <Popconfirm
              title="Are you sure you want to Unarchive this record?"
              onConfirm={() => handleRestore(record?.id)} // Correctly access `id`
              onCancel={() => message.info('Action cancelled')}
              okText="Yes"
              cancelText="No"
            >
              <ArchiveRestore className="ArchiverestorImg" />
            </Popconfirm>
          </Tooltip>
        </Space>
      ),
    },

  ];

  const handlePageSizeChange = (current, size) => {
    setPage(1); // Reset to first page if needed
    setPageSize(size); // You must have a setter or state update
  };

  return (
    <>
      <div className='sticyaction'>
        <Row className="pagenamerow" justify="space-between" align="middle">
          <Col>
            <h2 style={{ margin: 0 }}>Archived Die Tools</h2>
            <div className="bredcrumbwrp">
              <Link onClick={() => navigate(-1)} className="back">
                <Back /> BACK
              </Link>
              <Breadcrumb
                items={[
                  { title: <Link to="/die-tool">Die Tools</Link> },
                  { title: 'Archive Die Tools' }
                ]}
              />
            </div>
          </Col>
          <Col>
            <Space size="large">
              <Input
                placeholder="Search"
                className='searchbox'
                prefix={<SearchOutlined />}
                value={search}
                style={{ width: 200 }}
                onChange={handleSearch}
              />
              <Link>
                <Tooltip placement="top" title={'Reset Filter'}>
                  <Button type="primary" disabled={!search} className='iconlink' onClick={resetFilter}>
                    <FilterIcon />
                  </Button>
                </Tooltip>
              </Link>


            </Space>
          </Col>
        </Row>
      </div>
      <div style={{ height: '100vh', display: 'flex', flexDirection: 'column' }}>
        <div style={{ flex: 1, overflow: 'auto' }}>
          <Table
            rowKey="id"
           // rowSelection={rowSelection}
            dataSource={Array.isArray(data) ? data : []}
            columns={columns}
            pagination={false}
            loading={status === 'loading'}
            onChange={handleTableChange}
             scroll={{
          x: 880, // Horizontal Scroll
          y: 400,  // Vertical Scroll with Fixed Header
        }}
          />
        </div>
        <div
          style={{
            position: 'sticky',
            bottom: 0,
            zIndex: 1000,
            background: '#fff',
            padding: 10,
            display: 'flex',
            justifyContent: 'flex-end',
          }}
        >
          <Pagination
            current={page}
            pageSize={pagesize}
            total={totalRecord}
            showSizeChanger
            onShowSizeChange={handlePageSizeChange}
            showTotal={total => `Total ${total} items`}
            onChange={handlePageChange}
            locale={{ items_per_page: 'Items / Page' }}
          />
        </div>
      </div>
    </>
  );
}
